/* Novyice: small animations that answer what the shopper just did. Pure enhancement. */
(() => {
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const added = (window.theme && window.theme.strings && window.theme.strings.added) || 'Added to cart';
  let pending = null;

  /* Remember which button and photo started an add-to-cart. */
  document.addEventListener('click', (e) => {
    const btn = e.target.closest('.buy__atc, .card form button[type="submit"]');
    if (btn) {
      const scope = btn.closest('.product, .card');
      const img = scope && (scope.querySelector('.gallery__slide:not([hidden]) .gallery__img, .gallery__img, .card__img'));
      pending = { btn, img, rect: img && img.getBoundingClientRect(), brect: btn.getBoundingClientRect(), at: Date.now() };
    }
    const rm = e.target.closest('.cart-line__remove');
    if (rm && !reduced) { const line = rm.closest('.cart-line'); if (line) line.classList.add('st-leaving'); }
    const q = e.target.closest('.qty__btn');
    if (q && !reduced) {
      const input = q.parentElement && q.parentElement.querySelector('.qty__input');
      if (input) {
        const up = q === q.parentElement.lastElementChild || /plus|increase|\+/.test((q.getAttribute('name') || '') + (q.getAttribute('aria-label') || '') + q.textContent);
        input.classList.remove('st-roll-up', 'st-roll-down'); void input.offsetWidth;
        input.classList.add(up ? 'st-roll-up' : 'st-roll-down');
      }
    }
  }, true);

  const fly = (img, rect, brect) => {
    if (!img || reduced || !img.animate) return;
    let from = rect || img.getBoundingClientRect();
    /* Photo scrolled out of view: launch a small copy from the button instead. */
    if (!from.width || from.top < -from.height * .5 || from.bottom > innerHeight + from.height * .5) {
      from = { left: brect.left + brect.width / 2 - 45, top: brect.top - 20, width: 90, height: 90 };
    }
    const target = document.querySelector('.drawer.is-open .cart-line__media') || document.querySelector('[data-cart-count]');
    const t = target ? (target.closest('a, button') || target).getBoundingClientRect() : { left: innerWidth - 40, top: 20, width: 24, height: 24 };
    const clone = document.createElement('img');
    clone.src = img.currentSrc || img.src; clone.alt = ''; clone.className = 'st-fly';
    const size = Math.min(from.width, from.height, 260);
    Object.assign(clone.style, { left: `${from.left + (from.width - size) / 2}px`, top: `${from.top + (from.height - size) / 2}px`, width: `${size}px`, height: `${size}px` });
    document.body.appendChild(clone);
    const dx = t.left + t.width / 2 - (from.left + from.width / 2);
    const dy = t.top + t.height / 2 - (from.top + from.height / 2);
    const s = Math.max(.12, Math.min(t.width, t.height) / size);
    clone.animate([
      { transform: 'translate(0,0) scale(1)', opacity: 1, borderRadius: '12px' },
      { transform: `translate(${dx * .55}px, ${dy * .35 - 60}px) scale(${(1 + s) / 2})`, opacity: 1, offset: .55 },
      { transform: `translate(${dx}px, ${dy}px) scale(${s})`, opacity: .2, borderRadius: '50%' }
    ], { duration: 900, easing: 'cubic-bezier(.65,0,.35,1)' }).onfinish = () => clone.remove();
  };

  /* Hero depth follows the pointer (mouse and trackpad only). */
  const stage = document.querySelector('.lux-hero__stage');
  if (stage && !reduced && matchMedia('(pointer: fine)').matches) {
    let tx = 0, ty = 0, x = 0, y = 0, raf = 0;
    const step = () => {
      x += (tx - x) * .08; y += (ty - y) * .08;
      stage.style.setProperty('--mx', x.toFixed(3)); stage.style.setProperty('--my', y.toFixed(3));
      raf = Math.abs(tx - x) + Math.abs(ty - y) > .002 ? requestAnimationFrame(step) : 0;
    };
    stage.addEventListener('pointermove', (e) => {
      const r = stage.getBoundingClientRect();
      tx = ((e.clientX - r.left) / r.width - .5) * 2; ty = ((e.clientY - r.top) / r.height - .5) * 2;
      if (!raf) raf = requestAnimationFrame(step);
    });
    stage.addEventListener('pointerleave', () => { tx = 0; ty = 0; if (!raf) raf = requestAnimationFrame(step); });
  }

  /* Polished steel catches the light: a soft highlight follows the pointer over product photos. */
  if (!reduced) {
    document.addEventListener('pointermove', (e) => {
      const m = e.target.closest && e.target.closest('.card__media');
      if (!m) return;
      const r = m.getBoundingClientRect();
      m.style.setProperty('--sx', `${((e.clientX - r.left) / r.width * 100).toFixed(1)}%`);
      m.style.setProperty('--sy', `${((e.clientY - r.top) / r.height * 100).toFixed(1)}%`);
      m.classList.add('st-lit');
    }, { passive: true });
    document.addEventListener('pointerout', (e) => {
      const m = e.target.closest && e.target.closest('.st-lit');
      if (m && !m.contains(e.relatedTarget)) m.classList.remove('st-lit');
    });
  }

  document.addEventListener('cart:updated', () => {
    if (!pending || Date.now() - pending.at > 6000) return;
    const { btn, img, rect, brect } = pending; pending = null;
    btn.setAttribute('data-st-added', added);
    btn.classList.remove('st-added'); void btn.offsetWidth; btn.classList.add('st-added');
    setTimeout(() => btn.classList.remove('st-added'), 1650);
    requestAnimationFrame(() => setTimeout(() => fly(img, rect, brect), 60));
  });
})();
